/* Arbove — Bande de réassurance : rotation d'un seul bénéfice à la fois sur mobile.
   Sur mobile (<=767px), n'affiche qu'un pilier, change toutes les X secondes (fade up en CSS).
   Sur desktop : tous les piliers visibles (rien à faire). */
(function () {
  if (window.__arrRotate) return;
  window.__arrRotate = true;

  function setup(sec) {
    var itemSel = sec.getAttribute('data-arr-item') || '.ar-reassure__item';
    var items = sec.querySelectorAll(itemSel);
    if (items.length < 2) return;

    var interval = parseInt(sec.getAttribute('data-arr-interval'), 10) || 3000;
    var mq = window.matchMedia('(max-width: 767px)');
    var idx = 0;
    var timer = null;

    function show(i) {
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-active', j === i);
      }
    }
    function clearActive() {
      for (var j = 0; j < items.length; j++) items[j].classList.remove('is-active');
    }
    function start() {
      idx = 0;
      show(0);
      timer = setInterval(function () {
        idx = (idx + 1) % items.length;
        show(idx);
      }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      clearActive();
    }
    function apply() {
      stop();
      if (mq.matches) start();
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function init() {
    var secs = document.querySelectorAll('[data-arr-rotate]');
    for (var i = 0; i < secs.length; i++) setup(secs[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
